import { gql } from "@apollo/client";

export const GET_CURRENT_USER = gql`
  query getCurrentUser {
    currentUser {
      __typename
      ... on CurrentUser {
        id
        firstname
        lastname
        username
        email
        phone_number
        timezone
        timezone_offset
        confirmation_code
        marketing_subscribe
        created_at
        telegram_chat_id
        slack_webhook_url
        registration_code_formatted
        device_cap
        asm_synced
        google_synced
        ad_synced
        account_status
        school_disabled
        google_authenticator_active
        role {
          id
          name
          permissions {
            name
            granted
          }
        }
        roles {
          id
          name
          permissions {
            name
            granted
          }
        }
        school_users {
          school_id
          school {
            id
            name
            allow_screen_share_configuration
            school_type {
              id
              name
            }
          }
          is_current
          role_id
          is_in_session
          school_device_defaults {
            school_id
            force_class_join
            override_force_class_join
            mg_chrome_version
            mg_ios_version
            screen_share_type
          }
        }
        pretend {
          id
          client_id
          owner_type
          owner_id
          created_at
          updated_at
          admin_user_id
          admin_username
          admin_firstname
          admin_lastname
        }
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;

export const CHANGE_CURRENT_USER_PASSWORD = gql`
  mutation changeCurrentUserPassword($input: ChangeCurrentUserPasswordInput!) {
    changeCurrentUserPassword(input: $input) {
      currentUser {
        id
        firstname
        lastname
        username
        email
        phone_number
        timezone
        timezone_offset
        confirmation_code
        marketing_subscribe
        created_at
        telegram_chat_id
        slack_webhook_url
        registration_code_formatted
        device_cap
        asm_synced
        google_synced
        ad_synced
        account_status
        school_disabled
        google_authenticator_active
        role {
          id
          name
          permissions {
            name
            granted
          }
        }
        roles {
          id
          name
          permissions {
            name
            granted
          }
        }
        school_users {
          school_id
          school {
            id
            name
            allow_screen_share_configuration
            school_type {
              id
              name
            }
          }
          is_current
          role_id
        }
      }
      currentUserId
      errors {
        __typename

        # handle specific problem
        ... on NotQuiteSureProblem {
          message
        }

        # interface handles generic problem
        ... on Problem {
          message
        }
      }
    }
  }
`;

export const QUERY_CURRENT_USER_GOOGLE_AUTHENTICATOR_QR = gql`
  query currentUserGoogleAuthenticatorQR {
    currentUserGoogleAuthenticatorQR {
      __typename
      ... on Base64Image {
        image
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;
